module.exports = __webpack_public_path__ + "img/faq_icon.269b5c16.svg";